import { PostTypeformSubmissionInput, TypeformSubmission } from '../types';
import { client } from './axiosClient';

export const postTypeformSubmission = async (
  data: PostTypeformSubmissionInput
) => {
  const res = await client.post('/typeform-submissions', data);
  return res.data;
};

export const getTypeformSubmissions = async (user_id?: string) => {
  const res = await client.get<TypeformSubmission[]>('/typeform-submissions', {
    params: {
      user_id,
    },
  });
  return res.data;
};
